var map = {
	"./en.json": "e312",
	"./es.json": "ef52",
	"./fr.json": "b16e",
	"./gr.json": "510a",
	"./nl.json": "b94d",
	"./pl.json": "1c57",
	"./ru.json": "3a06",
	"./ua.json": "ebe7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36c0";